import React, { useEffect, useState } from 'react';
import { Container, Row, Col, FormInput, FormGroup, Form, Button, FormSelect, Card } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import Input from '../../../components/UI/Input/Input';
import Select from '../../../components/UI/Select/Select';
import useForm from './useForm';
import { useTranslation } from 'react-i18next';
import AutoComplete from '../../../components/UI/AutoComplete/AutoComplete';
import { LinearProgress } from '@material-ui/core';

const AddStudent = ({ role }) => {
  const { submitHandler, resetFormState, loading, field, establishments, back } = useForm({ role });
  const { t, i18n } = useTranslation();

  return (
    <>
      {loading && <LinearProgress />}

      <Container fluid className="main-content-container px-4 pb-4">
        <Row noGutters className="page-header py-4">
          <PageTitle sm="4" title={t('student.title.add')} subtitle={t('student.subTitle')} className="text-sm-left" />
        </Row>

        <Row>
          <Col>
            <Card small className="mb-4 py-5 px-4">
              <form>
                <Row>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.firstName')}
                      label={t('label.firstName')}
                      {...field('firstName')}
                    />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.lastName')}
                      label={t('label.lastName')}
                      {...field('lastName')}
                    />
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.gender')} label={t('label.gender')} {...field('gender')}>
                      <option value="" disabled selected>
                        {t('gender')}
                      </option>
                      <option value="F">{t('female')}</option>
                      <option value="M">{t('male')}</option>
                    </Select>
                  </Col>
                  <Col md="6">
                    <Input 
                      type="date" 
                      placeholder={t('placeholder.birthDate')} 
                      label={t('label.birthDate')} 
                      {...field('birth_date')} 
                    />
                  </Col>

                  <Col md="6">
                    <Input type="text" placeholder={t('placeholder.phone')} label={t('label.phone')} {...field('phone')} />
                  </Col>
                  <Col md="6">
                    <Input
                      type="text"
                      placeholder={t('placeholder.matricule-bac')}
                      label={t('label.matricule-bac')}
                      {...field('bac_matricule')}
                    />
                  </Col>
                  <Col md="6">
                    <Input 
                      type="email" 
                      placeholder={t('placeholder.email')} 
                      label={t('label.email')} 
                      {...field('email')} 
                    />
                    <small className="form-text text-muted">
                      {t('student.emailOptional')}
                    </small>
                  </Col>
                  <Col md="6">
                    <Select placeholder={t('placeholder.level')} label={t('label.level')} {...field('level')}>
                      <option value="" disabled selected>
                        {t('personal-information.label.chooselevel')}
                      </option>
                      <optgroup label={t('system-LMD')}>
                        <option value="lmd-licence1">{t('personal-information.form.lmd-licence1')}</option>
                        <option value="lmd-licence2">{t('personal-information.form.lmd-licence2')}</option>
                        <option value="lmd-licence3">{t('personal-information.form.lmd-licence3')}</option>
                        <option value="lmd-master1">{t('personal-information.form.lmd-master1')}</option>
                        <option value="lmd-master2">{t('personal-information.form.lmd-master2')}</option>
                      </optgroup>
                      <optgroup label={t('system-classic-1')}>
                        <option value="classic-1-ingeniorat1">{t('personal-information.form.classic-1-ingeniorat1')}</option>
                        <option value="classic-1-ingeniorat2">{t('personal-information.form.classic-1-ingeniorat2')}</option>
                        <option value="classic-1-ingeniorat3">{t('personal-information.form.classic-1-ingeniorat3')}</option>
                        <option value="classic-1-ingeniorat4">{t('personal-information.form.classic-1-ingeniorat4')}</option>
                        <option value="classic-1-ingeniorat5">{t('personal-information.form.classic-1-ingeniorat5')}</option>
                      </optgroup>
                      <optgroup label={t('system-classic-2')}>
                        <option value="classic-2-licence1">{t('personal-information.form.classic-2-licence1')}</option>
                        <option value="classic-2-licence2">{t('personal-information.form.classic-2-licence2')}</option>
                        <option value="classic-2-licence3">{t('personal-information.form.classic-2-licence3')}</option>
                        <option value="classic-2-licence4">{t('personal-information.form.classic-2-licence4')}</option>
                        <option value="classic-2-magister1">{t('personal-information.form.classic-2-magister1')}</option>
                        <option value="classic-2-magister2">{t('personal-information.form.classic-2-magister2')}</option>
                      </optgroup>
                      <optgroup label={t('other')}>
                        <option value="other-class-preparatoire">
                          {t('personal-information.form.other-class-preparatoire')}
                        </option>
                        <option value="other-class-medecine">{t('personal-information.form.other-class-medecine')}</option>
                        <option value="other-class-teacher">{t('personal-information.form.other-class-teacher')}</option>
                        <option value="phd">{t('personal-information.form.phd')}</option>
                      </optgroup>
                    </Select>
                  </Col>
                  {role !== 'ESTABLISHMENT_USER' && (
                    <Col md="6">
                      <AutoComplete
                        placeholder={t('placeholder.establishment')}
                        label={t('label.establishment')}
                        {...field('establishmentId', 'autoComplete')}
                        data={establishments}
                        valueObject="id"
                        titleObject="name"
                      />
                    </Col>
                  )}

                  <Col md="12" className="d-flex justify-content-end">
                    <Button theme="info" disabled={loading} onClick={() => back()}>
                      {t('annuler')}
                    </Button>
                    &nbsp; &nbsp;
                    <Button theme="success" type="button" disabled={loading} onClick={() => submitHandler()}>
                      {t('create')}
                    </Button>
                  </Col>
                </Row>
              </form>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default AddStudent;
